import usePushUrlParams from 'modules/reports/hooks/pushUrlParams'
import Response from 'modules/reports/orm/Response'
import {SearchState} from './useSearch.state'

type SearchOffset = {
  start: number
  end: number
}

export default function useSearchFetch<TModel, TParams, TFilters, TDisplay>(
  [state, setState]: [SearchState, Function],
  fetcher: (data: any) => Promise<Response<TModel[]>>,
  rowCapacity: number
) {
  const pushUrlParams = usePushUrlParams()

  function buildRequestData(state: SearchState) {
    return {q: state.query, sort: state.sort, ...state.filters}
  }

  async function fetch(
    stateChange?: Partial<SearchState<TModel, TParams, TFilters, TDisplay>>,
    offset?: SearchOffset
  ) {
    if (!offset) offset = {start: 0, end: rowCapacity}

    const inlineRequest = fetcher({...state.params, ...buildRequestData(state), ...(offset || {})})
    const newState: SearchState = {
      ...state,
      ...stateChange,
      request: inlineRequest,
      response: undefined,
    }
    setState(newState)

    pushUrlParams(buildRequestData(newState))

    const inlineResponse = await inlineRequest
    const inlineData = inlineResponse.data

    setState((state: SearchState) => {
      const data: (TModel | undefined)[] = Array(inlineResponse.total).fill(undefined)
      data.splice(0, state.data.length, ...state.data)
      data.splice(offset!.start, inlineData.length, ...inlineData)

      return {
        ...state,
        response: inlineResponse,
        total: inlineResponse.total,
        data,
      }
    })

    return inlineResponse
  }

  return fetch
}
